module.exports = __webpack_public_path__ + "img/navbar-bg.3da87837.png";